(() => {
  const directory = document.querySelector('[data-kb-faq-directory]');
  const search = document.querySelector('[data-kb-faq-search]');
  if (!directory || !search) return;

  const clearButton = document.querySelector('[data-kb-faq-clear]');
  const emptyState = document.querySelector('[data-kb-faq-empty]');
  const groups = [...directory.querySelectorAll('[data-kb-faq-group]')];
  const categoryButtons = [...directory.querySelectorAll('[data-kb-faq-category-link]')];

  const filterFaqs = () => {
    const query = search.value.trim().toLocaleLowerCase();
    let matches = 0;
    groups.forEach((group) => {
      let groupMatches = 0;
      group.querySelectorAll('[data-kb-faq-item]').forEach((item) => {
        const matched = !query || item.dataset.searchText.includes(query);
        item.hidden = !matched;
        if (matched) groupMatches += 1;
      });
      group.hidden = groupMatches === 0;
      matches += groupMatches;
    });
    clearButton.hidden = !query;
    emptyState.hidden = matches !== 0;
  };

  const clearSearch = () => {
    search.value = '';
    filterFaqs();
    search.focus();
  };

  search.addEventListener('input', filterFaqs);
  search.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && search.value) clearSearch();
  });
  clearButton.addEventListener('click', clearSearch);

  groups.forEach((group) => {
    group.querySelectorAll('details').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        group.querySelectorAll('details[open]').forEach((openDetails) => {
          if (openDetails !== details) openDetails.open = false;
        });
      });
    });
  });

  categoryButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const group = directory.querySelector(`[data-kb-faq-group="${button.dataset.kbFaqCategoryLink}"]`);
      if (!group) return;
      group.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (!visible) return;
      categoryButtons.forEach((button) => button.classList.toggle('is-active', button.dataset.kbFaqCategoryLink === visible.target.dataset.kbFaqGroup));
    }, { rootMargin: '-25% 0px -60% 0px', threshold: [0, 0.1, 0.25] });
    groups.forEach((group) => observer.observe(group));
  }
})();
